import React from 'react';
//mui
import { Box, Table, TableBody, TableCell, TextField } from '@mui/material';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

import { makeStyles } from '@mui/styles';
import { getNumberComma } from '../../../utils/numberUtils';

const useStyles = makeStyles({
  table: {
    '& .MuiTableCell-root': {
      border: '1px solid rgba(224, 224, 224, 1)',
      align: 'center',
    },
  },
});

const SalesBillHistoryList = ({ history }) => {
  const classes = useStyles();

  return (
    <Box sx={{ overflow: 'auto', my: 1 }}>
      <TableContainer
        size="small"
        className={classes.table}
        sx={{ width: '100%', display: 'table', tableLayout: 'fixed' }}
      >
        <Table padding="none">
          <TableHead>
            <TableRow>
              <TableCell align="center">회차</TableCell>
              <TableCell align="center">매출 일자<br/>(작성 일자)</TableCell>
              <TableCell align="center">매출처</TableCell>
              <TableCell align="center">매출 내용</TableCell>
              <TableCell align="center">해외</TableCell>
              <TableCell align="center">총 매출 금액</TableCell>
              <TableCell align="center">매출 금액</TableCell>
              <TableCell align="center">부가세</TableCell>
              <TableCell align="center">매출 합계</TableCell>
              <TableCell align="center">수금 예정 일자</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {history && history.length > 0 ? (
              history.map((item, index) => (
                <TableRow key={index}
                  sx={{ 
                    '& .MuiTableCell-root': { 
                      fontSize: '0.875rem', 
                      padding: '8px 4px', // 셀 패딩 통일
                      textAlign: 'center',
                      verticalAlign: 'middle' 
                    },
                    '& .MuiInputBase-root': {
                      fontSize: '0.875rem',
                      margin: '0 auto',
                      marginTop: 0, // 상단 여백 제거
                    },
                    '& .MuiInputBase-input': { 
                      padding: '2px 0 3px 0', // 텍스트와 하단 선 사이 간격 조절
                      textAlign: 'center' 
                    },
                    // 에러 메시지가 라인을 밀어내지 않도록 설정
                    '& .MuiFormHelperText-root': {
                      position: 'absolute',
                      bottom: '-18px',
                      margin: 0,
                      fontSize: '0.65rem',
                      whiteSpace: 'nowrap'
                    },
                    '& .MuiIconButton-root': { p: '4px' },
                    '& .number-cell': { 
                      textAlign: 'right',
                      fontVariantNumeric: 'tabular-nums' // 숫자 폭을 일정하게 고정
                    },
                  }}
                >
                  <TableCell sx={{width:30}}>{index+1}</TableCell>
                  <TableCell align="center" sx={{ width: 120, px: 1 }}>{item?.reqCompDt}</TableCell>
                  <TableCell sx={{ width: 160 }}>{item?.partnerNm}</TableCell>
                  <TableCell>{item?.invTxt}</TableCell>
                  <TableCell align="center" sx={{ width: 50 }}>{item?.osTran}</TableCell>
                   <TableCell align="center" sx={{ width: 160 }}>
                    {getNumberComma(item?.billSumTotal)}
                  </TableCell>
                  <TableCell align="center" sx={{ width: 160 }}>
                    {getNumberComma(item?.invAmt)}
                  </TableCell>
                  <TableCell align="center" sx={{ width: 160 }}>
                    {getNumberComma(item?.invVat)}
                  </TableCell>
                  <TableCell align="center" sx={{ width: 160 }}>
                    {getNumberComma(item?.invTot)}
                  </TableCell>
                  <TableCell align="center" sx={{ width: 160 }}>{item?.prodCompDt}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={10} align="center">
                  등록된 매출 계산서가 없습니다.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default SalesBillHistoryList;
